import { ColumnType } from '../util/types'

export const knivesColumns: ColumnType[] = [
  // 编号
  {
    label: 'sideHoleMachine.knifes.number',
    props: 'knifeName',
    canEdit: true,
    width: 90,
    align: 'center',
  },
  // 刀宽
  {
    label: 'sideHoleMachine.knifes.diameter',
    props: 'diameter',
    canEdit: true,
    width: 90,
    isInputCheck: true,
    align: 'center',
  },
  // 换刀开始代码
  {
    label: 'sideHoleMachine.knifes.startCode',
    props: 'startCode',
    canEdit: true,
    isTextarea: true,
    align: 'center',
  },
  // 换刀结束代码
  {
    label: 'sideHoleMachine.knifes.endCode',
    props: 'endCode',
    canEdit: true,
    isTextarea: true,
    align: 'center',
  },
]

export const codeList = [
  // 设备启动代码
  {
    title: 'sideHoleMachine.equipmentParams.equipStartCode',
    key: 'beginCode',
    elementId: 'span_0qijqqzu1p',
  },
  // 设备暂停代码
  {
    title: 'sideHoleMachine.equipmentParams.equipPauseCode',
    key: 'pauseCode',
    elementId: 'span_78elyffdlj',
  },
  // 设备结束代码
  {
    title: 'sideHoleMachine.equipmentParams.equipEndCode',
    key: 'endCode',
    elementId: 'span_sn3v9lr2mj',
  },
  // 左面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.leftTurnCode',
    key: 'leftTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 左面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.leftTurnEndCode',
    key: 'leftTurnEndCode',
    elementId: 'span_45w45v3ej4',
  },
  // 下面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.downTurnCode',
    key: 'backTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 下面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.downTurnEndCode',
    key: 'backTurnEndCode',
    elementId: 'span_ca1h50wup8',
  },
  // 右面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.rightTurnCode',
    key: 'rightTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 右面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.rightTurnEndCode',
    key: 'rightTurnEndCode',
    elementId: 'span_ca1h50wup8',
  },
  // 上面开始代码
  {
    title: 'sideHoleMachine.equipmentParams.frontTurnCode',
    key: 'frontTurnCode',
    elementId: 'span_6p5822sud1',
  },
  // 上面结束代码
  {
    title: 'sideHoleMachine.equipmentParams.frontTurnEndCode',
    key: 'frontTurnEndCode',
    elementId: 'span_ca1h50wup8',
  },
]

export const holeSetting = [
  // 加工命令
  {
    title: 'sideHoleMachine.workOrder',
    key: 'holeCutCode',
    elementId: 'span_fm6gztpxnj',
  },
]
export const slotSetting = [
  // 加工命令
  {
    title: 'sideHoleMachine.workOrder',
    key: 'slotCutCode',
    elementId: 'span_fm6gztpxnj',
  },
]

// 拉米诺设置
export const lmlSetting = [
  // 加工命令
  {
    title: 'sideHoleMachine.workOrder',
    key: 'lmlCutCode',
    elementId: 'span_fm6gztpxnj',
  },
]

// 榫卯设置
export const mtSetting = [
  // 直槽加工
  {
    title: 'sideHoleMachine.slot',
    key: 'mtLineCutCode',
    elementId: 'span_fm6gztpxnj',
  },
  // 圆弧加工
  {
    title: 'sideHoleMachine.cirWork',
    key: 'mtArcCutCode',
    elementId: 'span_fm6gztpxnj',
  },
]
// 文件设置
export const fileSetting = [
  // 文件编码格式设置
  {
    title: 'cuttingDock.NCExportSettings.codeFormatSetting',
    key: 'file_encode',
    elementId: 'span_w1443ngj8t',
  },
  // 换行符格式设置
  {
    title: 'cuttingDock.NCExportSettings.lineBreakSetting',
    key: 'use_win_line_feeds',
    elementId: 'span_hu1tgxwz3l',
  },
]
